import * as z from "zod";
import { dropConnectorUsage, usageRef } from "../connectorUsages";
import { mutator } from "./mutator";

export const dissociateBranchChatFromConnectedApp = mutator({
  description: "Removes a connector’s approval for use in workflow chats.",
  interactionType: "delete",
  schema: z.object({
    branchId: z.string(),
    connectedAppId: z.string(),
  }),
  resolve: {
    branch: { kind: "branch", from: "branchId" },
  },
  permissions: [
    {
      permission: "space:write",
      scopeId: ({ args }) => args.branch.workflow.spaceId,
    },
  ],
  fn: async ({ tx, args: { branch, connectedAppId } }) => {
    await dropConnectorUsage(
      tx,
      connectedAppId,
      usageRef.workflowChat(branch.workflowId)
    );
  },
});
